const BusinessCities = [
    { value: "Abu Dhabi", label: "Abu Dhabi" },
    { value: "Dubai", label: "Dubai" },
    { value: "Sharjah", label: "Sharjah" },
    { value: "Ajman", label: "Ajman" },
    { value: "Ras Al Khaimah", label: "Ras Al Khaimah" },
    { value: "Fujairah", label: "Fujairah" },
    { value: "Umm Al Quwain", label: "Umm Al Quwain" },
    { value: "Al Ain", label: "Al Ain" },
]

const BusinessBrandsRegion = [
    { value: "American", label: "American" },
    { value: "European", label: "European" },
    { value: "Japanese", label: "Japanese" },
    { value: "Korean", label: "Korean" },
    { value: "Chinese", label: "Chinese" },
]

export const testingBusinessIds = [250801, 250807, 250808, 250809, 250811, 250812, 250814, 250817, 250824, 250835, 250875, 250982, 250983, 250984, 251169, 251188, 251276]


const GetOrdersStatus = (item) => {
    const statusMapping = {
        0: {
            label: "Pending",
            className: "badge bg-warning text-uppercase"
        },
        1: {
            label: "Assigned",
            className: "badge bg-primary text-uppercase"
        },
        2: {
            label: "Accepted",
            className: "badge bg-success text-uppercase"
        },
        3: {
            label: "Packed",
            className: "badge bg-info text-uppercase"
        },
        4: {
            label: "Shipped",
            className: "badge bg-dark text-uppercase"
        },
        5: {
            label: "Delivered",
            className: "badge bg-success text-uppercase"
        },
        6: {
            label: "Cancelled",
            className: "badge bg-danger text-uppercase"
        },
        7: {
            label: "Returned",
            className: "badge bg-danger text-uppercase"
        },
        8: {
            label: "Returned Collected",
            className: "badge bg-secondary text-uppercase"
        },
        9: {
            label: "Returned Received",
            className: "badge bg-warning text-uppercase"
        },
        10: {
            label: "Partially Accept",
            className: "badge bg-primary text-uppercase"
        },
        11: {
            label: "Partially Cancelled",
            className: "badge bg-danger text-uppercase"
        },
        12: {
            label: "Partially Packed",
            className: "badge bg-info text-uppercase"
        },
        13: {
            label: "Out for Delivery",
            className: "badge bg-secondary text-uppercase"
        },
        14: {
            label: "Packed To Central Hub",
            className: "badge bg-secondary text-uppercase"
        },
        15: {
            label: "Out For Delivery To Central Hub",
            className: "badge bg-secondary text-uppercase"
        },
        16: {
            label: "Delivered To Central Hub",
            className: "badge bg-secondary text-uppercase"
        },
    };

    return (
        statusMapping[item.item_status] || {
            label: "Unknown",
            className: "badge bg-secondary text-light text-uppercase"
        }
    );
};

const GetSortByStatus = [
    { value: "1", label: "Most Popular" },
    { value: "2", label: "New Arrival" },
    { value: "3", label: "Limited Offer" },
]


const GetPointsRangeData = (minPoints, maxPoints) => {
    const ranges = [
        { min_points: 0, max_points: 100 },
        { min_points: 100, max_points: 500 },
        { min_points: 500, max_points: 1000 },
        { min_points: 1000, max_points: 5000 },
        { min_points: 5000, max_points: 10000 },
        { min_points: 10000, max_points: 50000 },
        { min_points: 50000, max_points: 100000 }
    ];

    return ranges
        // .filter(range => range.max_points <= maxPoints)
        .map(range => ({
            value: `${range.min_points}-${range.max_points}`,
            label: `${range.min_points.toLocaleString()} - ${range.max_points.toLocaleString()}`,
            min_points: range.min_points,
            max_points: range.max_points
        }));
};

const GetCashRangeData = (minPoints, maxPoints) => {
    const ranges = [
        { min_points: 0, max_points: 100 },
        { min_points: 100, max_points: 500 },
        { min_points: 500, max_points: 1000 },
        { min_points: 1000, max_points: 5000 },
        { min_points: 5000, max_points: 10000 }
    ];

    return ranges
        // .filter(range => range.max_points <= maxPoints)
        .map(range => ({
            value: `${range.min_points}-${range.max_points}`,
            label: `${range.min_points.toLocaleString()} - ${range.max_points.toLocaleString()}`,
            min_points: range.min_points,
            max_points: range.max_points
        }));
};

export {
    BusinessCities,
    BusinessBrandsRegion,
    GetOrdersStatus,
    GetSortByStatus,
    GetPointsRangeData,
    GetCashRangeData
}